
import { Component, NgZone, Input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { IAppConfig } from 'src/config/app-config.model';

@Component({
  selector: 'adahi-news-list-shared',
  templateUrl: './news-list-shared.component.html'
})
export class NewsListSharedComponent extends BaseTranslation {
  
  @Input() list: string;
  @Input() appSettings: IAppConfig;

  constructor(translate: TranslateService, ngZone: NgZone) {
    super( translate,ngZone);
  }

}
